module.exports = __webpack_public_path__ + "ty1-01cfb223.png";